<template>
  <div class="home-external-commercial">
    <ContentHome />
  </div>
</template>

<script>
import ContentHome from "../Home/ContentHome/Custom.vue";

export default {
  components: {
    ContentHome
  }
};
</script>
